module.exports = __webpack_public_path__ + "img/slide-1-mob.269f0c0.webp";